import React from "react";
import { extendedStatesList } from "components/haven-design/state-picker";
import { SelectAutocomplete } from "./select-autocomplete";

const filterOptions = (options: string[], state: {inputValue: string}) => extendedStatesList
  .filter(({ value }) => options.includes(value))
  .filter(({ label, value }) =>
    label.toLowerCase().includes(state.inputValue.toLowerCase()) ||
      value.toLowerCase().includes(state.inputValue.toLowerCase()))
  .map(({ value }) => value);

export const SelectState: React.FC<any> = (props) => {
  const options = props.includeStates ? extendedStatesList
    .filter(state => props.includeStates.includes(state.value)) : extendedStatesList;

  return (
    <SelectAutocomplete
      {...props}
      filterOptions={filterOptions}
      options={options}
    />
  );
};
